import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/dist/locale/he';
import englishTranslation from './languages/en.json';
import heTranslation from './languages/he.json';

i18next.use(initReactI18next).init({
    lng: 'en',
    debug: true,
    resources: {
        en: {
            translation: englishTranslation,
        },
        he: {
            translation: heTranslation,
        },
    },
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});

moment.locale(i18next.language);
i18next.on('languageChanged', (lang) => moment.locale(lang));
